import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: grid;
  grid-template-rows: auto auto;
  gap: 50px;
  border-radius: 24px 24px 0px 0px;
`;

export const Routes = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  color: ${({ theme }) => theme.colors.neutral.white};
  ${({ theme }) => theme.font.heading.xs};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  cursor: pointer;
`;

export const Parent = styled.p`
  margin: 0px 4px;
  cursor: pointer;
  ${({ theme }) => theme.font.heading.xs};
  font-weight: ${({ theme }) => theme.font.weight.regular};

  &:hover {
    text-decoration: underline;
  }
`;

export const Highlight = styled.p`
  ${({ theme }) => theme.font.heading.xs};
  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const PageName = styled.p`
  ${({ theme }) => theme.font.heading.sm};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const ExternalWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.neutral.white};
  padding: 16px;
  box-shadow: 0px -8px 16px 0px
    ${({ theme }) => theme.colors.primary.cetaceanBlue}20;

  button {
    width: 100%;
  }

  ${media.greaterThan("1200px")`
    box-shadow: none;
    padding: 0;
    position: relative;
    width: 100%;
    background-color: transparent;
    padding: 0;

    button {
      width: auto;
    }
  `}
`;
